// 实时画面  页面
import React, { useEffect, useRef, useState } from 'react'
import { Spin, Card, Button, Radio, message, Space } from 'antd';
import warning from '@/common/img/video/warning.svg';
import { getLiveAddress } from '@/server/video'
import "./index.css"
import VideoPatrolMonitor from './video_patrol_monitor.js'

function Video (props) {
  const mapkeys = [
    '86d93748cf75968bb768bfb9ff4b19fc',
    '86d93748cf75968bb768bfb9ff4b19fc',
    '86d93748cf75968bb768bfb9ff4b19fc',
  ];//天地图key
  const [choose_map_key, setChooseMapKey] = useState();
  const mapRef = useRef();
  const [zoom, setZoom] = useState(17); //地图缩放比例

  const token = localStorage.getItem('dock_token');
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false)
  const [stateList, setStateList] = useState({
    chooseType: 1,//当前选择的监控类型
  })//状态列表

  const [errorMessage, setErrorMessage] = useState(
    {
      error_heard: '',
      error_code: '',
      error_value: '',
    }
  )//返回的错误信息

  // 错误参数列表
  const playerErrorInfo = [
    {
      code: '4001',
      value: '参数不合理。',
    },
    {
      code: '4002',
      value: '鉴权过期。',
    },
    {
      code: '4003',
      value: '无效地址。',
    },
    {
      code: '4004',
      value: '地址不存在。',
    },
    {
      code: '4005',
      value: '开始下载数据错误，检测网络情况或播放地址是否可以访问。',
    },
    {
      code: '4006',
      value: '开始下载元数据错误。',
    },
    {
      code: '4007',
      value: '播放时错误。',
    },
    {
      code: '4008',
      value: '加载超时，检测网络情况或播放地址是否可以访问。',
    },
    {
      code: '4009',
      value: '请求数据错误，测网络情况或播放地址是否可以访问。',
    },
    {
      code: '4010',
      value: '不支持阿里云视频加密（私有加密）播放。',
    },
    {
      code: '4011',
      value: '播放格式不支持。',
    },
    {
      code: '4012',
      value: 'playauth解析错误。',
    },
    {
      code: '4013',
      value: '播放数据解码错误MEDIA_ERR_DECODE，检测浏览器是否支持视频格式。',
    },
    {
      code: '4014',
      value: '网络不可用。',
    },
    {
      code: '4015',
      value: '获取数据过程被中止MEDIA_ERR_ABORTED。',
    },
    {
      code: '4016',
      value: '播网络错误加载数据失败MEDIA_ERR_NETWORK。',
    },
    {
      code: '4017',
      value: '返回的播放地址为空。',
    },
    {
      code: '4100',
      value: '信令请求失败。',
    },
    {
      code: '4110',
      value: '不支持webrtc。',
    },
    {
      code: '4111',
      value: '不支持此浏览器。',
    },
    {
      code: '4112',
      value: '浏览器版本过低。',
    },
    {
      code: '4113',
      value: '不支持H264。',
    },
    {
      code: '4114',
      value: 'create offer失败。',
    },
    {
      code: '4115',
      value: '自动播放失败。',
    },
    {
      code: '4116',
      value: '播放URL协议错误。',
    },
    {
      code: '4118',
      value: '订阅时候传入的HtmlElement既不是Audio也不是Video。',
    },
    {
      code: '4200',
      value: '播放失败。',
    },
    {
      code: '4400',
      value: '未知错误MEDIA_ERR_SRC_NOT_SUPPORTED（由于服务器或网络原因不能加载资源，或者格式不支持）。',
    },
    {
      code: '4500',
      value: '服务端请求错误，查看Network里点播服务的请求的具体错误。',
    },

  ]

  //获取直播地址
  const liveAddress = async (type) => {
    setTimeout(async () => {
      document.getElementById('Fplayer_dock').innerHTML = ''
      setLoading(true)
      let obj = {
        access_token: token,
        camera: 'dock',
      }
      let res = await getLiveAddress(obj)
      if (res.ret !== 200 || res.data.state === 0) {
        setLoading(false)
        return
      }

      setIsOpen(true)
      // 创建阿里云播放器dom
      const Fplayer = document.getElementById('Fplayer_dock')
      const Cplayer = document.createElement('div')
      Fplayer.display = 'none'
      Cplayer.id = 'J_prismPlayer'
      Fplayer.appendChild(Cplayer)
      let url = res.data?.dock[type]
      // let url = 'artc://video.9zhouzhineng.com/dock/drone_01'//无人机
      // let url = 'https://video.9zhouzhineng.com/dock/drone_01.flv'//无人机备用
      // let url = 'artc://video.9zhouzhineng.com/dock/m3_01'//机场
      // let url = 'https://video.9zhouzhineng.com/dock/m3_01.flv'//机场备用
      StartVideoFun(url)
    }, 500);
  }

  //开启直播
  const StartVideoFun = async (url) => {
    console.log('当前直播的地址为：', url);
    setIsOpen(true)
    let player = new Aliplayer(
      {
        id: `J_prismPlayer`,
        source: url,//视频的播放凭证，可以在通用媒体管理服务控制台获取。
        width: '100%', //容器的大小
        height: '100%',
        format: "video",
        mediaType: "video",
        autoplay: true,
        isLive: true,
        rePlay: true,
        playsinline: true,
        preload: true,
        controlBarVisibility: "hover",
        useH5Prism: true,
        skinLayout: [
          { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
          { name: "H5Loading", align: "blabs", x: "calc(50% - 30px)", y: 'calc(50% - 30px)' },
          {
            name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              { name: "liveDisplay", align: "tlabs", x: 15, y: 6 },
              { name: "fullScreenButton", align: "tr", x: 10, y: 10 },
            ]
          }
        ],
        components: [
          { name: 'adComponent', type: StaticAdComponent },
        ]
      }, (player) => {
        //console.log("播放器创建成功~");
      }
    );
  };

  // Aliplayer配置生命周期
  const StaticAdComponent = Aliplayer.Component({
    play: () => {

    },
    waiting: () => {
    },
    playing: () => {
      setLoading(false);
      console.log('正在播放中');
    },
    error: (player, e) => {
      setIsOpen(false)
      console.log('error:', e);
      setLoading(false)
      let obj = { ...errorMessage }
      if (e) {
        obj.error_heard = e.display_msg ? e.display_msg : e.error_msg
        obj.error_code = e.error_code
        obj.error_value = playerErrorInfo.find((res) => e.error_code === Number(res.code))?.value
        setErrorMessage({ ...obj })
      }
      // setIsLive(false)
    },
    ended: (player, e) => {
      console.log("直播已结束");
      console.log("player", player);
      console.log("e", e);
      setIsOpen(false)
    }
  })

  useEffect(() => {
    if (stateList.chooseType === 1) {
      liveAddress(0)
    }

    // eslint-disable-next-line
  }, [])

  return (
    <div className="hidden pd24 box hei100" id='main'>
      <Card>
        {/* 单择框 */}
        <div className='pdTB16 flex jcsb'>
          <Radio.Group
            value={stateList.chooseType}
            buttonStyle="solid"
            onChange={(e) => {
              let sta = stateList
              sta.chooseType = e.target.value
              setStateList({ ...sta })
              if (e.target.value === 1) {
                liveAddress(0)
              } else {
                document.getElementById('J_prismPlayer').remove()
              }
            }}
          >
            <Radio.Button value={1}>机场监控</Radio.Button>
            <Radio.Button value={2}>巡检监控</Radio.Button>
          </Radio.Group>
          {
            stateList.chooseType === 1 && <Radio.Group
              defaultValue='0'
              buttonStyle="solid"
              onChange={(e) => {
                liveAddress(e.target.value)
              }}
            >
              <Radio.Button value="0">地址1</Radio.Button>
              <Radio.Button value="1">地址2</Radio.Button>
            </Radio.Group>
          }

        </div>
        <Card
          className='hidden'
          style={{ height: 'calc(100vh - 224px)', backgroundColor: '#1D1D1D', }}
          bodyStyle={{ padding: '0', margin: '0' }}
        >
          {
            stateList.chooseType === 1
              ?
              (
                // <Spin spinning={loading}>
                <div>
                  {/* 直播容器 */}
                  <div className='radius8 hidden' style={{ height: 'calc(100vh - 224px)', width: 'calc(100vw - 297px)', display: isOpen ? `` : `none` }}>
                    <div id='Fplayer_dock' style={{ width: '100%', height: '100%', }}></div>
                  </div>
                  {/* 错误提示框 */}
                  <div className='flex_col jcc align_center' style={{ height: 'calc(100vh - 224px)', width: 'calc(100vw - 297px)', display: isOpen ? `none` : `` }}>
                    <div className='marB24'>
                      <img src={warning} alt='warning' />
                    </div>
                    {/* 提示文字 */}
                    <div className='marB24 flex_col jcc'>
                      <span className='fw400 fs24 lh32'>请确认域名是否配置了https证书或者是否开启了允许跨域访问</span>
                      <span className='fw400 fs14 lh22 tc opa45'>error_code:4009 请求数据错误，测网络情况或播放地址是否可以访问。</span>
                    </div>
                    {/* 底部按钮 */}
                    <div>
                      <Space>
                        <Button onClick={() => { liveAddress(0) }}>Try Again</Button>
                      </Space>
                    </div>
                  </div>
                </div>
                //  </Spin> 
              )
              :
              (
                <div>
                  {true
                    ? <div><VideoPatrolMonitor /></div>
                    :
                    (
                      <Card
                        className='hidden'
                        style={{ height: 'calc(100vh - 224px)', backgroundColor: '#1D1D1D', }}
                        bodyStyle={{ padding: '0', margin: '0' }}
                      >
                        暂无数据
                      </Card>
                    )
                  }
                </div>
              )
          }
        </Card>
      </Card >

    </div >
  )
}
export default Video